import { render, staticRenderFns } from "./Portrait.vue?vue&type=template&id=1fd34f64&scoped=true"
import script from "./Portrait.vue?vue&type=script&lang=js"
export * from "./Portrait.vue?vue&type=script&lang=js"
import style0 from "./Portrait.vue?vue&type=style&index=0&id=1fd34f64&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1fd34f64",
  null
  
)

export default component.exports